import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import Lang from '/@/modules/core/app/services/Lang';

export class EntityLang extends BaseService {
  /**
   * @returns {function}
   */
  get t() {
    return Lang.t.bind(Lang);
  }
}
